import * as React from 'react';
const SvgCheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
        <circle cx={11} cy={11} r={11} fill="currentColor" />
        <path d="M7 11.647L9.56 14 15 9" stroke="#fff" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default SvgCheckCircle;
